// Lightweight client for posting error logs to the backend
import web3Config from '../web3/web3Config.json';
import { generateOpenApiTokens } from './cryptoToken.js';
const BASE_URL = (web3Config?.EMAIL_API || '').replace(/\/+$/,'');
const ERROR_LOG_URL = `${BASE_URL}/logs`;

// Central function to post error payloads
export async function reportError({
	endpoint = '-',
	message = '-',
	error = '-',
	userName = '-',
	level = 'error',
	apps = 'DMail',
	source = 'web',
	metadata = {},
}) {
	const payload = {
		source,
		apps,
		level,
		endpoint,
		message,
		error,
		user_name: userName || undefined,
		metadata: {
			method: metadata.method || undefined,
			status: metadata.status ?? undefined,
			...metadata,
		},
	};

	try {
		const token = await generateOpenApiTokens();
		await fetch(ERROR_LOG_URL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				...(token && { 'x-api-token': `${token}` })
			},
			body: JSON.stringify(payload),
			keepalive: true,
		});
	} catch {
		// Swallow to avoid secondary failures; logging errors must never crash the app
	}
}

// Helpers to serialize errors safely
export function toErrorString(err) {
	if (!err) return '';
	if (err instanceof Error) {
		return `${err.name}: ${err.message}${err.stack ? `\n${err.stack}` : ''}`;
	}
	if (typeof err === 'object') {
		try {
			return JSON.stringify(err);
		} catch {
			return String(err);
		}
	}
	return String(err);
}